import {
  Component,
  ViewEncapsulation,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

import { GlobalHeaderDataService } from "../../global-header/global-header-data.service";
import { Subscription } from "rxjs";
import {
  VAIconRegistryService,
  checkCircle,
  infoCircle,
} from "@va/core-library/icons";

@Component({
  selector: "app-notification-renderer",
  templateUrl: "./notification-renderer.component.html",
  styleUrls: ["./notification-renderer.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationRendererComponent {
  @ViewChild(TemplateRef) template: TemplateRef<{}>;

  subscription: Subscription;
  faExclamationCircle = faExclamationCircle;
  constructor(
    private notification: NzNotificationService,
    private headerService: GlobalHeaderDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([infoCircle, checkCircle]);
    this.subscription = this.headerService.notificationShow$.subscribe(
      (data) => {
        this.notification.template(this.template, {
          nzClass:
            data.type === "success"
              ? "success main"
              : data.type === "error"
                ? "error main"
                : data.type === "info"
                  ? "info main"
                  : "warning main",
          nzData: data,
        });
      },
    );
  }
}
